// extracted by mini-css-extract-plugin
export default {"unsubscribeWrap":"Unsubscribe_unsubscribeWrap__REqWq","unsubscribe_form":"Unsubscribe_unsubscribe_form__BKVn4"};